import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function permissionGroupPermissionDelete(requestor) {
  return createReduxPromiseAction(
    ActionTypes.PERMISSION_GROUP_PERMISSION_DELETE,
    (permissionGroupId, permissionId) =>
      requestor
        .delete(
          `${basePath}/permission_group/${permissionGroupId}` +
            `/permission/${permissionId}`,
          {withCredentials: true},
        )
        .then(() => ({
          permissionGroupId,
          permissionId,
        })),
  );
}
